/**
 * @file     RayInfoTooltip.tsx
 * @purpose  Info icon that reveals a tooltip identifying Ray as the licensed Realtor.
 */
'use client';

import { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from 'next/link';

const TooltipContent = () => (
  <Box sx={{ maxWidth: 220, p: 0.5 }}>
    <Typography variant="body2" sx={{ fontSize: 13, lineHeight: 1.5 }}>
      I am Ray Rasouli. I am the licensed Realtor in charge of this business. You can read more about me{' '}
      <Link
        href="/about-ray"
        style={{ color: 'inherit', textDecorationColor: 'rgba(255,255,255,0.6)' }}
      >
        here
      </Link>
      .
    </Typography>
  </Box>
);

export const RayInfoTooltip = () => {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip
      title={<TooltipContent />}
      open={open}
      onClose={() => setOpen(false)}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      placement="bottom-start"
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'rgba(30,30,30,0.97)',
            backdropFilter: 'blur(8px)',
            borderRadius: '10px',
            boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
            px: 1.5,
            py: 1,
            '& .MuiTooltip-arrow': { color: 'rgba(30,30,30,0.97)' },
          },
        },
      }}
    >
      <IconButton
        size="small"
        onClick={() => setOpen((v) => !v)}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        aria-label="About Ray Rasouli"
        sx={{
          p: 0.25,
          ml: 0.75,
          verticalAlign: 'middle',
          color: 'text.secondary',
          '&:hover': { color: 'text.primary' },
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="8" r="0.5" fill="currentColor" stroke="none" />
          <line x1="12" y1="12" x2="12" y2="17" />
        </svg>
      </IconButton>
    </Tooltip>
  );
};
